exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-line-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;height:1rem;line-height:1rem;font-size:.4rem;border-bottom:1px solid #eee}.lineTitle{text-align:left;padding:.2rem;font-size:16px;background-color:orange;color:#fff;border-radius:5px;margin-top:.2rem;margin-bottom:.2rem}", ""]);

// exports
